import {
  dataRequestBegin,
  dataRequestLoading,
  dataRequestCompleted,
  dataRequestFailure,
  dataRequestCancelled,
  dataRequestStatusReset,
} from 'app/dealer/shared/higherOrderReducers/withDataRequest/actionTypeFormatters';

import { LEADS_BENCHMARK_REDUCER_NAME } from '../constants';

export const leadsBenchmarkDataRequestBegin = payload =>
  dataRequestBegin(LEADS_BENCHMARK_REDUCER_NAME, payload);

export const leadsBenchmarkDataRequestLoading = () =>
  dataRequestLoading(LEADS_BENCHMARK_REDUCER_NAME);

export const leadsBenchmarkDataRequestComplete = payload =>
  dataRequestCompleted(LEADS_BENCHMARK_REDUCER_NAME, payload);

export const leadsBenchmarkDataRequestCancelled = payload =>
  dataRequestCancelled(LEADS_BENCHMARK_REDUCER_NAME, payload);

export const leadsBenchmarkDataRequestFailure = payload =>
  dataRequestFailure(LEADS_BENCHMARK_REDUCER_NAME, payload);

export const leadsBenchmarkDataResetStatusRequest = payload =>
  dataRequestStatusReset(LEADS_BENCHMARK_REDUCER_NAME, payload);
